import moment from "moment"
import PropTypes from "prop-types"
import React, {useMemo} from "react"
import {connect} from "react-redux"
import {Link} from "react-router-dom"
import {useTranslation} from "react-i18next"

const icon = require("~/icons/article_32_blue.svg")

const ListItemArticle = ({
  update,
  disableActions,
  usingLotNumber,
  ...article
}) => {
  const {t} = useTranslation()
  const locationText = useMemo(() => {
    const locationStocks = article.stocks.filter(
      stock =>
        stock && stock.storage_place && stock.storage_place.type === "Location"
    )
    if (locationStocks.length === 0) {
      return false
    } else {
      const baseText = `${article.current_quantity} ${article.product.unit} ${t(
        "products.detail.stored"
      )}`
      if (locationStocks.length === 1) {
        return `${baseText} (${locationStocks[0].storage_place.name})`
      } else {
        return `${baseText} (${t("products.detail.multipleWarehouses")})`
      }
    }
  }, [article.stocks])

  const destinationText = useMemo(() => {
    const destinationStocks = article.stocks.filter(
      stock =>
        stock &&
        stock.storage_place &&
        stock.storage_place.type === "Destination"
    )
    if (destinationStocks.length === 0) {
      return false
    } else {
      const baseText = `${article.stocked_out_quantity} ${
        article.product.unit
      } ${t("products.detail.fullyBooked")}`
      if (destinationStocks.length === 1) {
        return `${baseText} (${destinationStocks[0].storage_place.name})`
      } else {
        return `${baseText} (${t("products.detail.multipleDestinations")})`
      }
    }
  }, [article.stocks])

  const lotNumber = article.lot_number

  const inventories = !!article.current_article_inventories.length
    ? article.current_article_inventories
        .map(inventory =>
          t("timestamp", {
            timestamp: moment(`${inventory.created_at}Z`).format(
              "DD.MM.YYYY, HH:mm"
            )
          })
        )
        .join(", ")
    : t("products.detail.noInventory")

  return (
    <div className="sh-list-item">
      <img src={icon} alt={"Article"} />
      <div className={"content"}>
        <Link to={`/article/${article.barcode}`}>
          <div className="primary">
            {article.product.name} &mdash; {article.barcode}
          </div>

          <div className="secondary">
            <span>
              {t("products.detail.expiryDate", {
                expiryDate: article.expiry_date || "n/a"
              })}
            </span>
            {locationText && <span>{locationText};</span>}
            {destinationText && <span>{destinationText}</span>}
            {usingLotNumber && lotNumber && (
              <span>
                {t("products.detail.lotNumber")} «<strong>{lotNumber}</strong>»
              </span>
            )}

            <span>
              {t("products.detail.lastInventory", {inventories: inventories})}
            </span>
          </div>
        </Link>
      </div>
    </div>
  )
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  const {usingLotNumber} = settings
  return {usingLotNumber}
}

ListItemArticle.propTypes = {
  update: PropTypes.func.isRequired,
  usingLotNumber: PropTypes.bool,
  disableActions: PropTypes.bool
}

export default connect(mapStateToProps)(ListItemArticle)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemArticle.js